// extracted by mini-css-extract-plugin
export default {"reviewsCardSkeleton":"reviewsCardSkeleton_cNAVa","body":"body_TQw2S","title":"title_ldoK_","subtitle":"subtitle_XQjB9","rating":"rating_tH71t","footer":"footer_qi1DF"};